import { Image, View } from "@aws-amplify/ui-react";
import { useMediaQuery } from "@mui/material";
import { images } from "constants/index";

export const OurPrograms = () => {
  const matches = useMediaQuery("(min-width:1100px)");
  return (
    <div className="relative flex flex-col w-full h-full p-5 pt-28 font-lolita-one">
      {/* Our Work */}
      <View className="relative flex flex-col px-5">
        <div className="text-[76px] font-bold text-black">Our Work</div>
        <View
          className={`relative flex py-5 ${
            matches ? "px-20" : "px-10"
          } bg-[rgb(230,222,202,0.5)] mt-[-25px]  shadow-2xl`}
        >
          <div>
            Environmental Hood Restoration is a community-led volunteer effort
            composed of local residents of East Flatbush, Brooklyn. We are
            focused on bringing together the neighborhood through engagement
            initiatives to help feed, clean, restore, repair, and give back to
            the local community. Our goal is to find innovative and sustainable
            solutions to the problems facing residents of East Flatbush and
            provide opportunities for them to participate in the enrichment of
            their own surroundings.
          </div>
        </View>
      </View>
      {/* Our Work */}

      {/* 90z Food Pantry */}
      <View
        className={`relative flex ${
          matches ? "" : "flex-col"
        } bg-[rgb(230,222,202,0.5)] mt-10 rounded-2xl shadow-2xl`}
      >
        <Image
          width={matches ? "50%" : ""}
          objectFit="cover"
          alt="food pantry"
          src={images.sk25}
        />
        <View className="relative flex flex-col p-5">
          <div className=" text-[56px] font-bold">90z Food Pantry</div>
          <View className="relative flex flex-col my-5 p-5 border-[5px] border-white shadow-2xl font-semibold">
            <div>Every Thursday at 1PM</div>
            <div>Corner of East 93rd and Rutland Road, Brooklyn, NY</div>
          </View>
          <div>
            The 90z & EHR has been committed to a weekly Food Giveaway that
            happens every Thursday from 1 pm at Rutland Plaza.
          </div>
          <div>
            We believe progress starts within our own community. The success of
            this year's standing event has built community engagement, connected
            people between and within different neighborhoods, and served our
            people with healthy fresh produce that can improve food deserts.
          </div>
        </View>
      </View>
      {/* 90z Food Pantry */}

      {/* Skateboarding Clinic */}
      <View
        className={`relative flex  ${
          matches ? "" : "flex-col"
        } bg-[rgb(230,222,202,0.5)] mt-10 rounded-2xl shadow-2xl`}
      >
        <View className="relative flex flex-col p-5">
          <div className=" text-[50px] font-bold ">Skateboarding Clinics</div>
          <View className="relative flex flex-col my-5 p-5 border-[5px] border-white shadow-2xl">
            <div className=" font-semibold">
              Visit our social media for the latest skateboarding clinic dates
              and locations!
            </div>
          </View>
          <div className=" px-5">
            We are committed to empowering our youth, between but not limited to
            the ages of 5 - 17, in every way as they transition from adolescence
            to adulthood via education and tangible life-skill building,
            including leadership, teamwork, responsibility, integrity, respect,
            accountability, and compassion. We do this through a multilateral
            approach that includes an active lifestyle such as skateboarding.
            This is done with our partners at the Harold Hunter Foudation.
          </div>
        </View>
        <Image
          objectFit="cover"
          alt="skate clinic"
          width={matches ? "40%" : ""}
          src={images.sk15}
        />
      </View>
      {/* Skateboarding Clinic */}

      {/* 90z Buda beans */}
      <View
        className={`relative flex  ${
          matches ? "" : "flex-col"
        } bg-[rgb(230,222,202,0.5)] mt-10 rounded-2xl shadow-2xl`}
      >
        <Image
          objectFit="cover"
          alt="buda beans"
          width={matches ? "50%" : ""}
          src={images.sk13}
        />
        <View className="relative flex flex-col p-5">
          <div className=" text-[56px] font-bold ">90z Buda Beans</div>
          <View className="relative flex flex-col my-5 p-5 border-[5px] border-white shadow-2xl font-semibold">
            <div>Every Saturday & Sunday during the Summer 11am-9pm</div>
            <div>Rutland Plaza - P.S 398 Schoolyard 60 E 93rd ST</div>
          </View>
          <div>Buda Bean Summer Tournaments:</div>
          <div className=" fon">
            Builds a strong sense of community Keeps our children active
            Encourages sportsmanship and team spirit Reduced violence in the 90z
            Promotes leadership and built a sense of confidence Provides a sense
            of accomplishment for the children
          </div>
        </View>
      </View>
      {/* 90z buda beans */}

      {/* 90z Beautification Project */}
      <View
        className={`relative flex  ${
          matches ? "" : "flex-col"
        } bg-[rgb(230,222,202,0.5)] mt-10 rounded-2xl shadow-2xl`}
      >
        <View className="relative flex flex-col p-5">
          <div className=" text-[50px] font-bold">
            90z Beautification Project
          </div>
          <View className="relative flex flex-col my-5 p-5 border-[5px] border-white shadow-2xl">
            <div>Stay tunned for future community clean-up dates.</div>
          </View>
          <div>
            Neighborhood beautification can improve the quality of life of the
            residents. Living in pleasant surroundings improves daily life and
            helps to cultivate deeper connections amongst our
            residents/friends/family. A well kept environment can improve the
            quality of life as well as relieve people of the many stressors
            related to their safety and wellbeing.
          </div>
        </View>
        <Image
          width={matches ? "40%" : ""}
          objectFit="cover"
          alt="beautification project"
          src={images.sk26}
        />
      </View>
      {/* 90z Beautification Project */}
    </div>
  );
};
